import { render, staticRenderFns } from "./DialogAttention.vue?vue&type=template&id=6b88048b&scoped=true&"
import script from "./DialogAttention.vue?vue&type=script&lang=js&"
export * from "./DialogAttention.vue?vue&type=script&lang=js&"
import style0 from "./DialogAttention.vue?vue&type=style&index=0&id=6b88048b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88048b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VDialog,VDivider})
